import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bc580304&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=bc580304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc580304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc580304')) {
      api.createRecord('bc580304', component.options)
    } else {
      api.reload('bc580304', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bc580304&scoped=true&", function () {
      api.rerender('bc580304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nQuYF99ZiKh4/JS/comp/SearchFilterTokens.vue"
export default component.exports